var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ColumnBaseComponent } from '../../../../../items/columns/base/columnbase.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
var KtsFlatpickrComponent = /** @class */ (function (_super) {
    __extends(KtsFlatpickrComponent, _super);
    function KtsFlatpickrComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.initValue1 = '2019/10/10 09:00';
        return _this;
    }
    KtsFlatpickrComponent.prototype.ngOnChanges = function (changes) {
    };
    KtsFlatpickrComponent.prototype.ngOnInit = function () {
        // super.ngOnInit();
    };
    KtsFlatpickrComponent.prototype.ngAfterViewInit = function () {
        var localeOptions = {
            weekdays: {
                shorthand: ['日', '月', '火', '水', '木', '金', '土'],
                longhand: [
                    '日曜日',
                    '月曜日',
                    '火曜日',
                    '水曜日',
                    '木曜日',
                    '金曜日',
                    '土曜日',
                ]
            },
            months: {
                shorthand: [
                    '1月',
                    '2月',
                    '3月',
                    '4月',
                    '5月',
                    '6月',
                    '7月',
                    '8月',
                    '9月',
                    '10月',
                    '11月',
                    '12月',
                ],
                longhand: [
                    '1月',
                    '2月',
                    '3月',
                    '4月',
                    '5月',
                    '6月',
                    '7月',
                    '8月',
                    '9月',
                    '10月',
                    '11月',
                    '12月',
                ]
            },
            time_24hr: true,
            rangeSeparator: ' から ',
            firstDayOfWeek: 1
        };
        var options = {
            // disableMobile: 'true',
            locale: localeOptions,
        };
        var self = this;
        flatpickr('#flatpickrTest1', Object.assign({}, options, {
            dateFormat: 'Y/m/d H:i',
            enableTime: true,
        }));
        flatpickr('#flatpickrTest2', Object.assign({}, options, {
            dateFormat: 'Y/m/d H:i:S',
            enableTime: true,
            enableSeconds: true,
        }));
        $('#flatpickrDateTest1').flatpickr(Object.assign({}, options, {
            dateFormat: 'Y/m/d',
            defaultDate: new Date(self.initValue1),
            onReady: function (selectedDates, dateStr, instance) {
                // console.log('onReady:', selectedDates[0], dateStr, instance);
                self.date1 = selectedDates[0];
            },
            onChange: function (selectedDates, dateStr, instance) {
                // console.log('onChange:', selectedDates[0], dateStr, instance);
                self.date1 = selectedDates[0];
            },
            onOpen: function (selectedDates, dateStr, instance) {
                // console.log('onOpen:', selectedDates[0], dateStr, instance);
                if (self.date2) {
                    this.set('maxDate', new Date(self.date2));
                }
                else {
                    this.set('maxDate', null);
                }
            },
        }));
        $('#flatpickrTimeTest1').flatpickr(Object.assign({}, options, {
            dateFormat: 'H:i',
            enableTime: true,
            noCalendar: true,
            defaultDate: new Date(self.initValue1),
            onReady: function (selectedDates, dateStr, instance) {
                // console.log('onReady:', selectedDates[0], dateStr, instance);
                self.time1 = selectedDates[0];
            },
            onChange: function (selectedDates, dateStr, instance) {
                // console.log('onChange:', selectedDates[0], dateStr, instance);
                self.time1 = selectedDates[0];
            },
            onOpen: function (selectedDates, dateStr, instance) {
                // console.log('onOpen:', selectedDates[0], dateStr, instance);
                // if (self.time2) {
                //     this.set('maxDate', new Date(self.time2));
                // }
            },
        }));
        $('#flatpickrDateTest2').flatpickr(Object.assign({}, options, {
            dateFormat: 'Y/m/d',
            onReady: function (selectedDates, dateStr, instance) {
                // console.log('onReady:', selectedDates[0], dateStr, instance);
                self.date2 = selectedDates[0];
            },
            onChange: function (selectedDates, dateStr, instance) {
                // console.log('onChange:', selectedDates[0], dateStr, instance);
                self.date2 = selectedDates[0];
            },
            onOpen: function (selectedDates, dateStr, instance) {
                // console.log('onOpen:', selectedDates[0], dateStr, instance);
                if (self.date1) {
                    this.set('minDate', new Date(self.date1));
                }
                else {
                    this.set('minDate', null);
                }
            },
        }));
        $('#flatpickrTimeTest2').flatpickr(Object.assign({}, options, {
            dateFormat: 'H:i',
            enableTime: true,
            noCalendar: true,
            onReady: function (selectedDates, dateStr, instance) {
                // console.log('onReady:', selectedDates[0], dateStr, instance);
                self.time2 = selectedDates[0];
            },
            onChange: function (selectedDates, dateStr, instance) {
                // console.log('onChange:', selectedDates[0], dateStr, instance);
                self.time2 = selectedDates[0];
            },
            onOpen: function (selectedDates, dateStr, instance) {
                // console.log('onOpen:', selectedDates[0], dateStr, instance);
                // if (self.time1) {
                //     this.set('minDate', new Date(self.time1));
                // }
            },
        }));
    };
    KtsFlatpickrComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-column-flatpickr',
                    template: "\n        <p class=\"sectionHeading\">flatpickr</p>\n        <div class=\"-ml-3\">\n            <dl class=\"form\">\n                <dt class=\"form_dt\"><label class=\"formLabelText\">\u65E5\u6642</label></dt>\n                <dd class=\"form_dd\">\n                    <ul>\n                        <li class=\"form_li\"><input type=\"text\" class=\"formInputText\" id=\"flatpickrTest1\"></li>\n                    </ul>\n                </dd>\n            </dl>\n            <dl class=\"form -mt-1\">\n                <dt class=\"form_dt\"><label class=\"formLabelText\">\u65E5\u6642(\u79D2\u4ED8\u304D)</label></dt>\n                <dd class=\"form_dd\">\n                    <ul>\n                        <li class=\"form_li\"><input type=\"text\" class=\"formInputText\" id=\"flatpickrTest2\"></li>\n                    </ul>\n                </dd>\n            </dl>\n            <dl class=\"form -mt-1\">\n                <dt class=\"form_dt\"><label class=\"formLabelText\">\u65E5\u6642(Form~To)</label></dt>\n                <dd class=\"form_dd\">\n                    <ul>\n                        <li class=\"form_li form_li-w150\"><input type=\"text\" class=\"formInputText\" id=\"flatpickrDateTest1\"></li>\n                        <li class=\"form_li form_li-w100\"><input type=\"time\" class=\"formInputText\" step=\"60\" id=\"flatpickrTimeTest1\"></li>\n                        <li class=\"form_li\">~</li>\n                        <li class=\"form_li form_li-w150\"><input type=\"text\" class=\"formInputText\" id=\"flatpickrDateTest2\"></li>\n                        <li class=\"form_li form_li-w100\"><input type=\"time\" class=\"formInputText\" step=\"60\" id=\"flatpickrTimeTest2\"></li>\n                    </ul>\n                </dd>\n            </dl>\n        </div>\n    "
                }] }
    ];
    /** @nocollapse */
    KtsFlatpickrComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    return KtsFlatpickrComponent;
}(ColumnBaseComponent));
export { KtsFlatpickrComponent };
//# sourceMappingURL=flatpickr.component.js.map